export const capitalize = (s: string): string => {
  if (typeof s !== 'string') return '';
  return s.charAt(0).toUpperCase() + s.slice(1);
};

const RELATIVE_TIME_UNITS = [
  { unit: 'year', seconds: 31_536_000 },
  { unit: 'month', seconds: 2_628_000 },
  { unit: 'week', seconds: 604_800 },
  { unit: 'day', seconds: 86_400 },
  { unit: 'hour', seconds: 3_600 },
  { unit: 'minute', seconds: 60 },
  { unit: 'second', seconds: 1 },
] as const;

export const getDurationStringUntilNow = (from: string, today: string, language: string): string => {
  const now = new Date();
  const fromDate = new Date(from);
  if (now.toDateString() === fromDate?.toDateString()) {
    return today;
  }

  const elapsedSeconds = (fromDate.getTime() - now.getTime()) / 1000;
  const { unit, seconds } =
    RELATIVE_TIME_UNITS.find(step => Math.abs(elapsedSeconds) >= step.seconds) ??
    RELATIVE_TIME_UNITS[RELATIVE_TIME_UNITS.length - 1];

  return new Intl.RelativeTimeFormat(language, { numeric: 'auto' }).format(Math.round(elapsedSeconds / seconds), unit);
};
